import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "../components/marketing/Navbar";
import { useAuth } from "../context/AuthContext";
import { api } from "../api";

export default function AcceptInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { user, refreshMe, switchWorkspace } = useAuth();
  const [invite, setInvite] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const inv = await api.inviteDetails(token);
        setInvite(inv);
      } catch (ex) {
        const detail = ex?.response?.data?.detail;
        if (Array.isArray(detail)) {
          setErr(detail.map(e => e.msg).join(", "));
        } else {
          setErr(detail || "Invite not found");
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const accept = async () => {
    setBusy(true);
    setErr("");
    try {
      const ws = await api.acceptInvite(token);
      await refreshMe();
      switchWorkspace(ws.id);
      nav("/app");
    } catch (ex) {
      const detail = ex?.response?.data?.detail;
      if (Array.isArray(detail)) {
        setErr(detail.map(e => e.msg).join(", "));
      } else {
        setErr(detail || "Could not accept invite");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-16">
        <h1 className="font-display text-4xl">You're invited.</h1>
        {loading ? (
          <p className="mt-4 text-sm text-[#6a736f]">Loading invite…</p>
        ) : err ? (
          <div className="mt-6 bg-white rounded-xl border border-cream p-6">
            <div className="text-sm text-red-600">{err}</div>
            <Link to="/" className="btn-outline-forest inline-block mt-4 px-4 py-2 rounded-md text-sm">Go home</Link>
          </div>
        ) : (
          <div className="mt-6 bg-white rounded-xl border border-cream p-6">
            <div className="text-sm text-[#3f4a44]">
              You've been invited to join <span className="font-semibold">{invite.workspace_name}</span> as <span className="font-medium">{invite.role}</span>.
            </div>
            <div className="text-xs text-[#6a736f] mt-1">Invite email: {invite.email}</div>
            {!user ? (
              <div className="mt-5">
                <p className="text-sm text-[#3f4a44]">Please sign in or create an account with the invited email to accept.</p>
                <div className="mt-4 flex gap-2">
                  <Link to="/signin" className="btn-coral px-4 py-2 rounded-md text-sm">Sign in</Link>
                  <Link to="/signup" className="btn-outline-forest px-4 py-2 rounded-md text-sm">Create account</Link>
                </div>
              </div>
            ) : (
              <button disabled={busy} onClick={accept} className="btn-coral mt-5 px-5 py-2.5 rounded-md text-sm font-medium">
                {busy ? "Joining…" : `Accept and join ${invite.workspace_name}`}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
